import { Input } from "../../components/usecase/Input";
import React, { useState, useEffect, useMemo } from "react";
import { Autocomplete, TextField, Checkbox } from "@mui/material";
import Chip from "@mui/material/Chip";
import CustomSelect from "../../components/usecase/select";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import Button from "@material-ui/core/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useHistory } from "react-router-dom";
import { useUserAuthentication } from "../../../../../utils/utils";
import { config } from "../../../../../config/config";
import { JsonPopover } from "../../components/usecase/JsonPopover";

export const UsecaseEditView = (props) => {
  const { user, admin_data, updateAlert, updateAdminInputs } = props;
  const [metadata, setMetadata] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [rowHasError, setRowHasError] = useState(false);
  const [isCancelDialogOpen, setIsCancelDialogOpen] = useState(false);
  const [isSaveDialogOpen, setIsSaveDialogOpen] = useState(false);
  const [isJsonDialogOpen, setIsJsonDialogOpen] = useState(false);
  const [currentJsonValue, setCurrentJsonValue] = useState({});
  const [currentJsonValueMetadata, setCurrentJsonValueMetadata] = useState({});
  const productMappingItems = Array.isArray(
    admin_data?.admin_metadata?.[admin_data?.current_document?.value || ""],
  )
    ? admin_data?.admin_metadata?.[admin_data?.current_document?.value || ""]
    : [];

  let api = config.api.api_url;
  const { login } = useUserAuthentication();
  let history = useHistory();
  const URL = history?.location?.pathname;
  const Use_Case_Name = URL.split("/").pop();

  const IS_SAVE_BUTTON_ENABLE = useMemo(() => {
    const originalMetadata = admin_data?.usecase_metadata || {};
    const currentMetadata = metadata || {};

    const KEYS = Object.keys(originalMetadata);

    const IS_ANY_META_EDITED = KEYS.some((key) => {
      return (
        JSON.stringify(originalMetadata[key]) !==
        JSON.stringify(currentMetadata[key])
      );
    });

    return IS_ANY_META_EDITED;
  }, [admin_data?.usecase_metadata, metadata]);

  const outlinedCNCButton = {
    borderColor: "#46596A",
    // background-color: #d7dadd,
    color: "#46596A",
    // width: '100%',
    fontFamily: "Hind Siliguri",
    fontSize: "12px",
    fontWeight: "bold",
    marginRight: "5px",
  };

  const containedButton = {
    color: "white",
    backgroundColor: "#46596A",
    fontFamily: "Hind Siliguri",
    fontSize: "12px",
    fontWeight: "bold",
    // marginLeft: "10px !important",
    marginRight: "5px",
    cursor: IS_SAVE_BUTTON_ENABLE ? "pointer" : "not-allowed",
  };

  const validation = () => {};

  const handleOnInputChange = (e, fieldName) => {
    const editedValue = e.target.value;

    // Get the original value from admin_data to check its type
    const originalValue = admin_data?.usecase_metadata?.[fieldName];

    let valueToSave = editedValue;

    // Determine if original value is a complex type (object or array)
    const isComplexType =
      originalValue &&
      typeof originalValue === "object" &&
      (Array.isArray(originalValue) || !Array.isArray(originalValue));

    // If the original value was a complex type (object or array), try to parse back
    if (isComplexType) {
      try {
        // Try to parse as JSON
        const parsedValue = JSON.parse(editedValue);

        // Validate that the parsed value is of the same type as original
        const originalIsArray = Array.isArray(originalValue);
        const parsedIsArray = Array.isArray(parsedValue);

        // Only save if types match
        if (originalIsArray === parsedIsArray) {
          valueToSave = parsedValue;
        }
        // If types don't match, keep as string (user is still typing)
      } catch (err) {
        // If parsing fails, keep it as string (user is still typing)
        valueToSave = editedValue;
      }
    }

    setMetadata((prev) => ({
      ...prev,
      [fieldName]: valueToSave,
    }));
  };

  const handleOnSelectChange = (key, val, fieldName) => {
    setMetadata((prev) => ({
      ...prev,
      [fieldName]: val,
    }));
  };

  const handleMultiSelectChange = (fieldName, newValue) => {
    setMetadata((prev) => ({
      ...prev,
      [fieldName]: newValue, // newValue is the array from Autocomplete
    }));
  };

  const handleRadioChange = (e, fieldName) => {
    setMetadata((prev) => ({
      ...prev,
      [fieldName]: e.target.checked, // Switch gives boolean via checked
    }));
  };

  const formatInputValue = (value) => {
    if (value === null || value === undefined) return "";
    if (Array.isArray(value)) return JSON.stringify(value, null);
    if (typeof value === "object") return JSON.stringify(value, null);
    return String(value);
  };

  const formatMultiSelectValue = (value) => {
    if (!value) return [];

    // If it's already an array
    if (Array.isArray(value)) {
      // If array of objects with label property, return as-is
      if (value.length > 0 && typeof value[0] === "object" && value[0]?.label) {
        return value;
      }
      // If array of objects without label, convert to {label, name} format
      if (
        value.length > 0 &&
        typeof value[0] === "object" &&
        !value[0]?.label
      ) {
        return value.map((v) => ({
          label: JSON.stringify(v),
          name: JSON.stringify(v),
          ...v, // preserve original object
        }));
      }
      // If array of strings, convert to {label, name} format
      if (value.length > 0 && typeof value[0] === "string") {
        return value.map((v) => ({ label: v, name: v }));
      }
      return value;
    }

    // If it's a string, split by comma and convert to {label, name} format
    if (typeof value === "string") {
      return value
        .split(/\s*,\s*/)
        .map((v) => v.trim())
        .map((v) => ({ label: v, name: v }));
    }

    // Otherwise return empty array
    return [];
  };

  const handleDialogOpen = () => {
    setIsSaveDialogOpen(true);
  };

  const handleDialogClose = () => {
    setIsSaveDialogOpen(false);
  };

  const handleSaveMetadata = async () => {
    try {
      const params = new URLSearchParams({
        usecase_name: admin_data?.current_document?.value || "",
        admin_id: "RGM_retailer_mapping",
      });
      const response = await fetch(
        api + `/admin/rgm_retailer_mapping/updatemetadata?${params}`,
        {
          method: "POST",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(metadata),
        },
      );

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });

          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      updateAlert({
        open: true,
        message: `Usecase metadata updated successfully`,
        severity: "success",
        closeFlag: true,
      });
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "success",
        closeFlag: true,
      });
    } finally {
      setIsSaveDialogOpen(false);
    }
  };

  function cancelFunction() {
    setIsCancelDialogOpen(false);
    updateAdminInputs("current_document", "");
    updateAdminInputs("usecase_metadata", {});
    updateAdminInputs("admin_metadata", {});
  }

  const handleJsonDialog = (item) => {
    setIsJsonDialogOpen(true);
    setCurrentJsonValue(metadata?.[item.name]);
    setCurrentJsonValueMetadata(item);
  };

  useEffect(() => {
    setMetadata(admin_data?.usecase_metadata || {});
  }, [admin_data]);

  return (
    <>
      <div
        style={{
          maxHeight: "74vh",
          overflowY: "auto",
          paddingRight: "15px",
        }}
      >
        {Array.isArray(
          admin_data?.admin_metadata?.[
            admin_data?.current_document?.value || ""
          ],
        ) ? (
          admin_data?.admin_metadata?.[
            admin_data?.current_document?.value || ""
          ]
            // ?.filter((f_item) =>
            //   admin_data.admin_metadata.editable_attributes?.[
            //     admin_data?.current_document?.value || ""
            //   ]?.includes(f_item.name),
            // )
            .map((item) => (
              <div
                key={item.name}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  width: "100%",
                  marginTop: "20px",
                }}
              >
                <label
                  style={{
                    fontSize: "16px",
                    color: "black",
                    minWidth: "180px",
                    fontWeight: "500",
                    wordBreak: "break-word",
                    margin: "0",
                  }}
                >
                  {item?.label || ""} :
                </label>

                <div style={{ flex: 1, width: "100%" }}>
                  {item.type === "input" ? (
                    <div
                      onClick={() => {
                        handleJsonDialog(item);
                      }}
                    >
                      <Input
                        errorMessage={errorMessage}
                        rowSize={2}
                        rowHasError={rowHasError}
                        columnDataArr={[]}
                        classes={{}}
                        type={item.type}
                        name={item.name}
                        onChange={(e) => handleOnInputChange(e, item.name)}
                        readonly={!item.editable}
                        value={formatInputValue(metadata?.[item.name])}
                        item={item.name}
                        childHasError={(bool) => setRowHasError(bool)}
                        error={""}
                        validation={validation}
                      />
                    </div>
                  ) : item.type === "select" ? (
                    <CustomSelect
                      errorMessage={errorMessage}
                      classes={""}
                      tableName={""}
                      name={item.name}
                      onChange={(key, val) =>
                        handleOnSelectChange(key, val, item.name)
                      }
                      options={[]}
                      customStyles={{}}
                      value={
                        metadata?.[item.name] === null ||
                        metadata?.[item.name] === "null"
                          ? ""
                          : metadata?.[item.name]
                      }
                      error={"error"}
                      selectMessage={item.label}
                      validation={""}
                      readonly={!item.editable}
                      showLabel={false}
                      derivedOptions={{}}
                      sourceData={admin_data}
                    />
                  ) : item.type === "multi-select" ? (
                    <Autocomplete
                      multiple
                      disableCloseOnSelect
                      options={[]}
                      disabled={!item.editable}
                      value={formatMultiSelectValue(metadata?.[item.name])}
                      onChange={(e, newValue) =>
                        handleMultiSelectChange(item.name, newValue)
                      }
                      getOptionLabel={(option) =>
                        typeof option === "string"
                          ? option
                          : option?.label || JSON.stringify(option)
                      }
                      isOptionEqualToValue={(option, value) =>
                        option?.name === value?.name
                      }
                      renderOption={(props, option, { selected }) => (
                        <li {...props}>
                          <Checkbox
                            checked={selected}
                            sx={{ padding: "2px", transform: "scale(0.9)" }}
                          />
                          {typeof option === "string"
                            ? option
                            : option?.label || JSON.stringify(option)}
                        </li>
                      )}
                      renderTags={(value, getTagProps) => (
                        <div
                          style={{
                            minHeight: "36px",
                            maxHeight: "120px",
                            overflowY: "auto",
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "4px",
                            paddingRight: "6px",
                            paddingTop: "0px",
                            paddingBottom: "0px",
                            margin: "0px",
                          }}
                        >
                          {value.map((option, index) => (
                            <Chip
                              key={index}
                              label={
                                typeof option === "string"
                                  ? option
                                  : option?.label || JSON.stringify(option)
                              }
                              size="small"
                              {...getTagProps({ index })}
                            />
                          ))}
                        </div>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          sx={{
                            "& .MuiInputBase-input": {
                              padding: "0px !important",
                              height: "20px !important",
                            },
                          }}
                        />
                      )}
                      sx={{
                        fontSize: "12px",
                        padding: "0px !important",
                        "& .MuiAutocomplete-inputRoot": {
                          minHeight: "fit-content",
                          minWidth: "280px",
                          width: "100%",
                          alignItems: "flex-start",
                          flexWrap: "wrap",
                          padding: "10px !important",
                          paddingbottom: "0px !important",
                        },
                        "& .MuiAutocomplete-tag": { margin: "2px" },
                      }}
                      slotProps={{
                        popper: {
                          sx: {
                            "& .MuiAutocomplete-listbox": { fontSize: "12px" },
                          },
                        },
                      }}
                    />
                  ) : item.type === "radio" ? (
                    // ─── RADIO GROUP ───────────────────────────────────────────
                    <FormControlLabel
                      control={
                        <Switch
                          checked={metadata?.[item.name]}
                          onChange={(e) => handleRadioChange(e, item.name)}
                          disabled={!item.editable}
                          sx={{
                            "& .MuiSwitch-switchBase.Mui-checked": {
                              color: "#ff4081", // pink thumb
                            },
                            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                              {
                                backgroundColor: "#ff4081", // pink track
                              },
                          }}
                        />
                      }
                      label={metadata?.[item.name] === true ? "Yes" : "No"}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        margin: "0",
                        gap: "8px",
                        "& .MuiFormControlLabel-label": {
                          fontSize: "15px",
                          fontWeight: 500,
                          color: "#333", // darker gray
                          margin: "0",
                        },
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        fontSize: "14px",
                        color: "#555",
                      }}
                    >
                      {formatInputValue(metadata?.[item.name])}
                    </div>
                  )}
                </div>
              </div>
            ))
        ) : (
          <>No Metadata Found</>
        )}

        {/* ACTION BUTTONS */}
        {Array.isArray(
          admin_data?.admin_metadata?.[
            admin_data?.current_document?.value || ""
          ],
        ) && (
          <div className="action-buttons">
            <div className="">
              <Button
                disableFocusRipple
                variant="outlined"
                style={outlinedCNCButton}
                onClick={() => setIsCancelDialogOpen(true)}
              >
                Cancel
              </Button>

              <Button
                disableFocusRipple
                style={containedButton}
                onClick={handleDialogOpen}
                disabled={!IS_SAVE_BUTTON_ENABLE}
              >
                <span>Save</span>
              </Button>
            </div>
          </div>
        )}
      </div>

      {/* JSON DIALOG */}
      {isJsonDialogOpen && (
        <JsonPopover
          value={currentJsonValue}
          currentJsonValueMetadata={currentJsonValueMetadata}
          admin_data={admin_data}
          setMetadata={setMetadata}
          updateAlert={updateAlert}
          updateAdminInputs={updateAdminInputs}
          outlinedCNCButton={outlinedCNCButton}
          containedButton={containedButton}
          isJsonDialogOpen={isJsonDialogOpen}
          setIsJsonDialogOpen={setIsJsonDialogOpen}
          rowHasError={rowHasError}
          setRowHasError={setRowHasError}
          errorMessage={errorMessage}
          setErrorMessage={setErrorMessage}
        />
      )}

      {/* SAVE DIALOG */}
      <div>
        <Dialog
          fullWidth={true}
          maxWidth={"sm"}
          open={isSaveDialogOpen}
          onClose={handleDialogClose}
        >
          <DialogTitle>Confirmation</DialogTitle>
          <DialogContent dividers>
            <DialogContentText>
              <p style={{ fontSize: "16px", color: "black" }}>
                The latest changes will be created as a new version. Do you want
                to continue?
              </p>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              disableFocusRipple
              variant="outlined"
              style={outlinedCNCButton}
              onClick={handleDialogClose}
            >
              Cancel
            </Button>
            <Button
              disableFocusRipple
              style={containedButton}
              onClick={handleSaveMetadata}
            >
              Continue
            </Button>
          </DialogActions>
        </Dialog>
      </div>

      {/* CANCEL DIALOG */}
      <div>
        <Dialog
          fullWidth={true}
          maxWidth={"sm"}
          open={isCancelDialogOpen}
          onClose={() => setIsCancelDialogOpen(false)}
        >
          <DialogTitle>Confirmation</DialogTitle>
          <DialogContent dividers>
            <DialogContentText>
              <p style={{ fontSize: "16px", color: "black" }}>
                The latest changes will be undone. Do you want to continue?
              </p>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              disableFocusRipple
              variant="outlined"
              style={outlinedCNCButton}
              onClick={() => setIsCancelDialogOpen(false)}
            >
              Cancel
            </Button>
            <Button
              disableFocusRipple
              style={{ ...containedButton, cursor: "pointer" }}
              onClick={cancelFunction}
            >
              Continue
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};
